import { Collapse } from "antd";
import ModuleCollapse from "./ModuleCollapse";
import VideoCard from "./VideoCard";

const moduleData = [
    {
        "id": 1,
        "name": "Union Find",
        "videos": [
            {
                "title": "Dynamic Connectivity",
                "userWatchPercentage": 0.3,
                "classMedianWatchPercentage": 0.55,
                "quizQuestionsCorrectlyAnswered": 1,
                "totalNumberOfQuizQuestions": 1,
                "totalNumberOfQnaQuestions": 0,
                "qnAStatistics": {"askedQuestions": [], "questionsRespondedTo": [], "receivedResponses": 0, "givenResponses": 0, "receivedInstructorResponses": 0},
                "quizQuestionStatistics": {"quizQuestion": {"id": 31, "video": 517, "title": "Connected Components", "startVideoTimestamp": 0.0, "endVideoTimestamp": 622.0, "text": {"blocks": [{"key": "oima", "data": {}, "text": "How many connected components result after performing the following sequence of union operations on a set of 10 items?\n1-2 \u00a0 3-4 \u00a0 5-6 \u00a07-8 \u00a07-9\u00a0 2-8 \u00a00-5 \u00a01-9.", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": []}], "entityMap": {}}, "images": [], "questionType": "select_one", "options": [{"id": 101, "optionText": {"blocks": [{"key": "bltsv", "data": {}, "text": "1", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": []}], "entityMap": {}}, "explanationText": {"blocks": [{"key": "77u35", "data": {}, "text": "Incorrect response. There is more than 1 connected component. For example, 0 and 3 are in different connected components.", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": [{"style": "BOLD", "length": 121, "offset": 0}]}], "entityMap": {}}, "image": null, "correctAnswerFlag": false}, {"id": 102, "optionText": {"blocks": [{"key": "3le8k", "data": {}, "text": "2", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": []}], "entityMap": {}}, "explanationText": {"blocks": [{"key": "fuil7", "data": {}, "text": "Incorrect response. There are more than 2 connected components. For example, 0, 1, 3 are in different connected components.", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": [{"style": "BOLD", "length": 123, "offset": 0}]}], "entityMap": {}}, "image": null, "correctAnswerFlag": false}, {"id": 103, "optionText": {"blocks": [{"key": "7hsh4", "data": {}, "text": "3", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": []}], "entityMap": {}}, "explanationText": {"blocks": [{"key": "430o", "data": {}, "text": "Correct. Yhe connected components are {0,5,6}, {3,4} and {1,2,7,8,9}", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": [{"style": "BOLD", "length": 68, "offset": 0}]}], "entityMap": {}}, "image": null, "correctAnswerFlag": true}, {"id": 104, "optionText": {"blocks": [{"key": "3ajp9", "data": {}, "text": "4", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": []}], "entityMap": {}}, "explanationText": {"blocks": [{"key": "8mo6c", "data": {}, "text": "Incorrect response. Try again.", "type": "unstyled", "depth": 0, "entityRanges": [], "inlineStyleRanges": [{"style": "BOLD", "length": 30, "offset": 0}]}], "entityMap": {}}, "image": null, "correctAnswerFlag": false}], "latestAttempt": {"selectedAnswers": [101], "maxCorrectAnswer": 1, "numCorrect": 0, "numIncorrect": 1, "submittedAt": "2022-07-27T01:39:06.810982-05:00"}}, "attempts": [{"selectedAnswers": [101], "maxCorrectAnswer": 1, "numCorrect": 0, "numIncorrect": 1, "submittedAt": "2022-07-27T01:38:55.855410-05:00"}, {"selectedAnswers": [101], "maxCorrectAnswer": 1, "numCorrect": 0, "numIncorrect": 1, "submittedAt": "2022-07-27T01:39:06.810982-05:00"}], "hasAnsweredCorrectly": false, "classMedianAttempts": 1, "classNumOfCorrectAnswerers": 1, "classMedianWatchCompletionOfCorrectAnswerers": 0.88, "choiceDistribution": [], "uniqueViewers": 1},
                "askedQuestions": [], 
                "questionsRespondedTo": [], 
                "receivedResponses": 0, 
                "givenResponses": 0, 
                "receivedInstructorResponses": 0,
                "videoStatistics": {
                    "classAvgPlaybackRate": 1.0, 
                    "classMedianWatchTime": 400, 
                    "userAvgPlaybackRate": 1.0, 
                    "userTimeSpent": 200
                }
                
            },
            {
                "title": "Quick Find",
                "userWatchPercentage": 0.7,
                "classMedianWatchPercentage": 0.63,
                "quizQuestionsCorrectlyAnswered": 0,
                "totalNumberOfQuizQuestions": 0,
                "totalNumberOfQnaQuestions": 0,
                "qnAStatistics": {"askedQuestions": [], "questionsRespondedTo": [], "receivedResponses": 0, "givenResponses": 0, "receivedInstructorResponses": 0},
                "quizQuestionStatistics": {},
                "askedQuestions": [], 
                "questionsRespondedTo": [], 
                "receivedResponses": 0, 
                "givenResponses": 0, 
                "receivedInstructorResponses": 0,
                "videoStatistics": {
                    "classAvgPlaybackRate": 1.0, 
                    "classMedianWatchTime": 400, 
                    "userAvgPlaybackRate": 1.0, 
                    "userTimeSpent": 200
                }
            }, 
            {
                "title": "Quick-Union",
                "userWatchPercentage": 0.1,
                "classMedianWatchPercentage": 0.64,
                "quizQuestionsCorrectlyAnswered": 0,
                "qnAStatistics": {"askedQuestions": [], "questionsRespondedTo": [], "receivedResponses": 0, "givenResponses": 0, "receivedInstructorResponses": 0},
                "quizQuestionStatistics": {},
                "totalNumberOfQuizQuestions": 0,
                "totalNumberOfQnaQuestions": 0,
                "askedQuestions": [], 
                "questionsRespondedTo": [], 
                "receivedResponses": 0, 
                "givenResponses": 0, 
                "receivedInstructorResponses": 0,
                "videoStatistics": {
                    "classAvgPlaybackRate": 1.0, 
                    "classMedianWatchTime": 400, 
                    "userAvgPlaybackRate": 1.0, 
                    "userTimeSpent": 200
                }
            },
            {
                "title": "Improvements",
                "userWatchPercentage": 0.54,
                "classMedianWatchPercentage": 0.43,
                "quizQuestionsCorrectlyAnswered": 0,
                "totalNumberOfQuizQuestions": 0,
                "qnAStatistics": {"askedQuestions": [], "questionsRespondedTo": [], "receivedResponses": 0, "givenResponses": 0, "receivedInstructorResponses": 0},
                "quizQuestionStatistics": {},
                "totalNumberOfQnaQuestions": 0,
                "askedQuestions": [], 
                "questionsRespondedTo": [], 
                "receivedResponses": 0, 
                "givenResponses": 0, 
                "receivedInstructorResponses": 0,
                "videoStatistics": {
                    "classAvgPlaybackRate": 1.0, 
                    "classMedianWatchTime": 400, 
                    "userAvgPlaybackRate": 1.0, 
                    "userTimeSpent": 200
                }
            },
            {
                "title": "Applications",
                "userWatchPercentage": 0.77,
                "classMedianWatchPercentage": 0.54,
                "quizQuestionsCorrectlyAnswered": 0,
                "qnAStatistics": {"askedQuestions": [], "questionsRespondedTo": [], "receivedResponses": 0, "givenResponses": 0, "receivedInstructorResponses": 0},
                "quizQuestionStatistics": {},
                "totalNumberOfQuizQuestions": 0,
                "totalNumberOfQnaQuestions": 0,
                "askedQuestions": [], 
                "questionsRespondedTo": [], 
                "receivedResponses": 0, 
                "givenResponses": 0, 
                "receivedInstructorResponses": 0,
                "videoStatistics": {
                    "classAvgPlaybackRate": 1.0, 
                    "classMedianWatchTime": 400, 
                    "userAvgPlaybackRate": 1.0, 
                    "userTimeSpent": 200
                }
            }
        ]
    }
]

const MockDashboardVideoAnalytics = () => {
    return (
        <div>
            <Collapse defaultActiveKey={1}>
            {
                moduleData.map((module, index) => {
                    return  <ModuleCollapse
                                module={module}
                                header={`${module.name}`}
                                key={module.id}
                                moduleIndex={index}
                            >
                                <div style={{display: "flex", flexWrap: "wrap"}}>
                                    {
                                        module.videos.map((video, j) => (
                                        
                                            <VideoCard
                                                module={module}
                                                video={video}
                                            />
                                        ))
                                    }
                                </div>
                            </ModuleCollapse>
                })
            }
           </Collapse>
           <br/>
        </div>
    )
}

export default MockDashboardVideoAnalytics;